var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.parcels),function(parcel,index){return _c('div',{key:index},[_c('iframe',{staticStyle:{"width":"100%","height":"500px"},attrs:{"src":parcel['parcel_label_url']}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }